import React from 'react';
import { MorphIcon, type IconInput, type MorphIconProps } from 'morphicons/react';

interface MorphingIconProps extends Omit<MorphIconProps, 'icon' | 'reducedMotion'> {
  icon: IconInput;
}

const MorphingIcon: React.FC<MorphingIconProps> = ({
  icon,
  size = 18,
  strokeWidth = 2,
  spring = 'snappy',
  className,
  ...props
}) => (
  <MorphIcon
    {...props}
    icon={icon}
    size={size}
    strokeWidth={strokeWidth}
    spring={spring}
    reducedMotion="user"
    className={['morphing-icon', className].filter(Boolean).join(' ')}
  />
);

export default MorphingIcon;
